import { Component } from '@theme/component';

/**
 * @typedef {object} Refs
 * @property {HTMLElement} daysGroup
 * @property {HTMLElement} hoursGroup
 * @property {HTMLElement} minutesGroup
 * @property {HTMLElement} days
 * @property {HTMLElement} hours
 * @property {HTMLElement} minutes
 *
 * @extends {Component<Refs>}
 */
class CountdownComponent extends Component {
  requiredRefs = ['daysGroup', 'hoursGroup', 'minutesGroup', 'days', 'hours', 'minutes'];

  /** @type {number | undefined} */
  #interval;

  /** @type {Date | null} */
  #startDate = null;

  /** @type {Date | null} */
  #expiryDate = null;

  connectedCallback() {
    super.connectedCallback();

    const expiryAttr = this.getAttribute('data-expiry');

    if (!expiryAttr) return;

    const startAttr = this.getAttribute('data-start');
    this.#startDate = startAttr ? this.#parseLocalDate(startAttr) : null;
    this.#expiryDate = this.#parseLocalDate(expiryAttr);

    this.#updateCountdown();
    this.#interval = setInterval(() => this.#updateCountdown(), 60_000);
  }

  disconnectedCallback() {
    super.disconnectedCallback();
    clearInterval(this.#interval);
  }

  /**
   * @param {string} str
   * @returns {Date}
   */
  #parseLocalDate(str) {
    const [datePart = '', timePart] = str.trim().split(' ');
    const [year = 0, month = 1, day = 1] = datePart.split('-').map(Number);
    const [hour = 0, minute = 0] = timePart ? timePart.split(':').map(Number) : [0, 0];

    return new Date(year, month - 1, day, hour, minute, 0);
  }

  #updateCountdown() {
    if (!this.#expiryDate) return;

    const now = new Date();
    const container = this.closest('.offer-bar__main');
    const parent = container?.closest('.offer-banner__parent');

    if ((this.#startDate && now < this.#startDate) || now > this.#expiryDate) {
      if (container instanceof HTMLElement) container.style.display = 'none';
      if (parent instanceof HTMLElement) parent.style.display = 'none';
      clearInterval(this.#interval);
      return;
    }

    if (container instanceof HTMLElement) container.style.display = '';

    const diff = this.#expiryDate.getTime() - now.getTime();
    const days = Math.floor(diff / (1000 * 60 * 60 * 24));
    const hours = Math.floor((diff / (1000 * 60 * 60)) % 24);
    const minutes = Math.floor((diff / (1000 * 60)) % 60);

    const { daysGroup, hoursGroup, minutesGroup } = this.refs;

    if (days >= 1) {
      daysGroup.style.display = '';
      hoursGroup.style.display = '';
      minutesGroup.style.display = 'none';
    } else {
      daysGroup.style.display = 'none';
      hoursGroup.style.display = '';
      minutesGroup.style.display = '';
    }

    this.refs.days.textContent = String(days);
    this.refs.hours.textContent = String(hours);
    this.refs.minutes.textContent = String(minutes);
  }
}

if (!customElements.get('countdown-component')) {
  customElements.define('countdown-component', CountdownComponent);
}
